export const BAR_LIMIT = 75;
export const CHART_TYPE = 'bar';
